import React from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import spinLogo from "../../images/PeerEase_icon.png";
import "./instructionNavbar.scss";
import { useNavigate } from "react-router-dom";

const InstructionNavigation = () => {
  const navigate = useNavigate();
  const handleNavigateLogin = () => {
    navigate(`/login`)
  }
  return (
    <Navbar expand="lg">
      <Navbar.Brand href="">
        <img alt="" src={spinLogo} />
        <span style={{ color: "#2c3972" }}>Peer</span>
        <span style={{ color: "#f78f1e" }}>Ease</span>
      </Navbar.Brand>
      <Nav className="ml-auto pr-20px">
        <Nav.Link href="">
          <Button onClick={handleNavigateLogin}>Start Using PeerEase</Button>
        </Nav.Link>
      </Nav>
    </Navbar>
  );
};

export default InstructionNavigation;
